export const USER_QUESTION_STATUS_SUBMITTED = 'SUBMITTED';
export const USER_QUESTION_STATUS_ASKED = 'ASKED';
export const USER_QUESTION_STATUS_ANSWERED = 'ANSWERED';
export const USER_QUESTION_STATUS_UNABLE_TO_ANSWER = 'UNABLE_TO_ANSWER';
export const USER_QUESTION_STATUS_HISTORICAL_NOT_KNOWN = 'HISTORICAL_NOT_KNOWN';

export const USER_QUESTION_STATUS_LIST = [
  USER_QUESTION_STATUS_SUBMITTED,
  USER_QUESTION_STATUS_ASKED,
  USER_QUESTION_STATUS_ANSWERED,
  USER_QUESTION_STATUS_UNABLE_TO_ANSWER,
  USER_QUESTION_STATUS_HISTORICAL_NOT_KNOWN,
];
